/* eslint-disable */
jQuery( function( $ ) {
	/**
	*  new_map
	*
	*  This function will render a Google Map onto the selected jQuery element
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	$el (jQuery element)
	*  @return	n/a
	*/

	const zoomLevel = 6;

	function newMap( $el ) {
		// var
		const $markers = $el.find( '.marker' );

		// vars
		const args = {
			zoom: zoomLevel,
			center: new google.maps.LatLng( 0, 0 ),
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			zoomControl: true,
			scaleControl: true,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			mapTypeControl: false,
			styles: [
				{
					featureType: 'administrative',
					elementType: 'labels.text.fill',
					stylers: [
						{
							color: '#9bb3b7',
						},
					],
				},
				{
					featureType: 'administrative',
					elementType: 'labels.text.stroke',
					stylers: [
						{
							color: '#ffffff',
						},
					],
				},
				{
					featureType: 'landscape',
					stylers: [
						{
							color: '#f8f9fa',
						},
					],
				},
				{
					featureType: 'poi',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road',
					stylers: [
						{
							saturation: -100,
						},
						{
							lightness: 45,
						},
					],
				},
				{
					featureType: 'road.arterial',
					elementType: 'labels.icon',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'road.highway',
					stylers: [
						{
							visibility: 'simplified',
						},
					],
				},
				{
					featureType: 'transit',
					stylers: [
						{
							visibility: 'off',
						},
					],
				},
				{
					featureType: 'water',
					stylers: [
						{
							color: '#eff3f3',
						},
						{
							visibility: 'on',
						},
					],
				},
			],
		};

		// create map
		const map = new google.maps.Map( $el[ 0 ], args );

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each( function() {
			addMarker( $( this ), map );
		} );

		// center map
		centerMap( map );

		// return
		return map;
	}

	/**
	*  add_marker
	*
	*  This function will add a marker to the selected Google Map
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	$marker (jQuery element)
	*  @param	map (Google Map object)
	*  @return	n/a
	*/

	function addMarker( $marker, map ) {
		// var
		const latlng = new google.maps.LatLng( $marker.attr( 'data-lat' ), $marker.attr( 'data-lng' ) );
		const baseUrl = document.location.origin;
		const icon = {
			url: baseUrl + '/wp-content/themes/mercuri/assets/images/icons/location.svg',
			origin: new google.maps.Point( 0, 0 ),
			anchor: new google.maps.Point( 29 / 2, 40 ),
			scaledSize: new google.maps.Size( 29, 40 ),
		};

		// create marker
		const marker = new google.maps.Marker( {
			position: latlng,
			map: map,
			icon: icon,
		} );

		// add to array
		map.markers.push( marker );

		// if marker contains HTML, add it to an infoWindow
		if ( $marker.html() ) {
			// Show/hide correct infowindow.
			google.maps.event.addListener( marker, 'click', function() {
				const position = this.getPosition();
				const latandlng = '#info' + position.lat() + '' + position.lng();
				const elemID = latandlng.split( '.' ).join( '' );
				$( '.acf-map__wrap .c-info-window' ).addClass( 'hidden' );
				$( elemID ).removeClass( 'hidden' );
			} );
		}
	}

	/**
	*  center_map
	*
	*  This function will center the map, showing all markers attached to this map
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	4.3.0
	*
	*  @param	map (Google Map object)
	*  @return	n/a
	*/

	function centerMap( map ) {
		// vars
		const bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each( map.markers, function( i, marker ) {
			const latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
			bounds.extend( latlng );
		} );

		map.setCenter( bounds.getCenter() );
		map.setZoom( zoomLevel );

		if( 1 !== map.markers.length ) {
			map.fitBounds(bounds);
		}
	}

	/**
	*  document ready
	*
	*  This function will render each map when the document is ready (page has loaded)
	*
	*  @type	function
	*  @date	8/11/2013
	*  @since	5.0.0
	*
	*  @param	n/a
	*  @return	n/a
	*/
	// global var
	let map = null;

	$( document ).ready( function() {
		$( '.acf-map' ).each( function() {
			// create map
			map = newMap( $( this ) );
		} );

		$( '.c-info-window .close' ).on( 'click', function() {
			$( this ).closest( '.c-info-window' ).addClass( 'hidden' );
		} );
	} );
} );
